import axios, { AxiosError } from "axios";
import { AuthTokenError } from "../../errors/authTokenError";

/**
 * Configuração para as APIs do FLOW
 * @param signOut - Função de logout
 * @param AuthorizationRA - Token de autorização do FLOW
 * @param Authorization - Token de autorização do RC
 * @returns Instância da API configurada
 */

export function SetupFlowRC(
  AuthorizationRA: string = "",
  Authorization: string = ""
) {
  const baseURL =
    import.meta.env.MODE === "production"
      ? import.meta.env.VITE_BASE_URL_PROD
      : import.meta.env.VITE_BASE_URL_DEV;

  const api = axios.create({
    baseURL,
    headers: {
      Authorization,
      AuthorizationRA,
      // 'ngrok-skip-browser-warning': '69420',
    },
  });

  api.interceptors.response.use(
    (response) => response,
    (error: AxiosError) => {
      if (error.response?.status === 401) {
        return typeof window === "undefined"
          ? Promise.reject(new AuthTokenError())
          : Promise.reject(error);
      }
      return Promise.reject(error);
    }
  );

  return api;
}
